import { Component, Input, OnInit, Output } from '@angular/core';
import { MapService } from '../../services/map.service';
import * as $ from 'jquery';
import { NotificationService } from '../../services/notification.service';
import { TranslateService } from '@ngx-translate/core';
import { LoadingService } from '../../services/loading.service';
import { Order, Voucher } from '../../../Api/models';
import { OrderApi, VoucherApi } from '../../../Api/services/custom';
import { EMAIL_REGEX, MUSIC } from '../../helper/constant';
import { Router } from '@angular/router';
import { createConsoleLogger } from '@angular-devkit/core/node';

declare const playSound: any;
let that: any;

@Component({
    selector: 'app-code',
    templateUrl: './code.component.html',
    styleUrls: ['./code.component.scss']
})
export class CodeComponent implements OnInit {
    @Input() type: string;
    inputCode = '';
    lock = true;
    activeResult = false;
    soundMute = false;
    order = new Order();
    assign = Object.assign;
    isExistVoucher = false;
    isLoading = false;
    voucherAccountId = 0;
    codeVoucher = '';

    constructor(private mapService: MapService,
                private noticationService: NotificationService,
                private translate: TranslateService,
                private loadingService: LoadingService,
                private orderApi: OrderApi,
                private router: Router,
                private voucherApi: VoucherApi) {
        that = Object.create(this.constructor.prototype);
    }

    ngOnInit() {
        this.soundMute = this.mapService.getSoundConfig();
    }

    unlockGame() {
        if (this.inputCode && this.inputCode.length >= 6) {
            const data: string = this.inputCode;
            this.inputCode = '';
            const deviceId = this.mapService.getDeviceId();
            if (!deviceId) {
                this.noticationService.create(this.translate.instant('core.active.cardError') + ', ' +
                    this.translate.instant('core.active.deviceIdError'));
                return;
            }
            this.loadingService.present();
            this.mapService.activeCard(data, deviceId).then((val) => {
                if (val === 'success') {
                    this.loadingService.dismiss();
                    this.lock = false;
                    this.activeResult = true;
                    $('.ma-kh').fadeOut(200, () => {
                        $(this).remove();
                    });
                    $('.popup-box').removeClass('transform-in').addClass('transform-out');
                    this.noticationService.create(this.translate.instant('core.active.cardSuccess'));
                    this.router.navigate(['']);
                } else if (val === 'expired') {
                    this.loadingService.dismiss();
                    this.activeResult = false;
                    this.noticationService.create(this.translate.instant('core.active.cardExpire'));
                } else {
                    this.loadingService.dismiss();
                    this.activeResult = false;
                    this.noticationService.create(this.translate.instant('core.active.cardError'));
                }
            }).catch((e: any) => {
                this.loadingService.dismiss();
                // console.log('Active card error', e);
                if (e.message === 'Card not found') {
                    this.noticationService.create(this.translate.instant('core.active.cardNotFound'));
                } else if (e.message === 'Card was active all') {
                    this.noticationService.create(this.translate.instant('core.active.cardActivePassTime'));
                } else if (e.message === 'Card was used') {
                    this.noticationService.create(this.translate.instant('core.active.cardUsed'));
                } else {
                    this.noticationService.create(this.translate.instant('core.active.cardError'));
                }
            });
        } else {

            this.noticationService.create(this.translate.instant('core.active.cardInputLength'));
        }
    }

    onClickForgotCard() {
        this.onClickClose();
        $('.forgot-ma-kh').fadeIn(100);
        $('.popup-box').removeClass('transform-out').addClass('transform-in');
    }

    onClickBuyCode() {
        this.onClickClose();
        $('.buy-code').fadeIn(100);
        $('.popup-box').removeClass('transform-out').addClass('transform-in');
    }

    onClickActive() {
        this.onClickClose();
        $('.ma-kh').fadeIn(100);
        $('.popup-box').removeClass('transform-out').addClass('transform-in');
    }

    onClickClose() {
        this.order = new Order();
        $('.ma-kh').fadeOut(200, () => {
            $(this).remove();
        });
        $('.forgot-ma-kh').fadeOut(200, () => {
            $(this).remove();
        });
        $('.buy-code').fadeOut(200, () => {
            $(this).remove();
        });

    }

    validateEmail(value) {
        if (EMAIL_REGEX.test(value)) {
            return true;
        }
        return false;
    }

    forgotCard() {
        if (!this.order.customerPhone) {
            this.noticationService.create(this.translate.instant('core.active.notiPhone'));
            return;
        }
        const customerMail = this.mapService.getAuthEmail();
        if (!customerMail) {
            this.noticationService.create(this.translate.instant('core.active.emailNotFound'));
            return;
        }
        this.loadingService.present();

        this.order.kind = 'RESET';
        this.order.commissionStatus = false;
        this.order.status = 'WAITING';
        this.order.customerNote = 'Reset mã thẻ game cho ID khách hàng: ' + this.mapService.getAuthEmail();
        this.order.orderName = 'Thẻ game';
        this.orderApi.create(this.order)
            .subscribe(() => {
                    this.onClickClose();
                    this.loadingService.dismiss();
                    this.noticationService.create(this.translate.instant('core.active.requestSuccess'));
                }, error => {
                    this.loadingService.dismiss();
                    this.noticationService.create((this.translate.instant('core.active.requestError') + error.message));
                }
            );


    }

    createOrder(codeVoucher: string) {
        if (!this.order.customerName) {
            this.noticationService.create(this.translate.instant('core.active.notiName'));
            return;
        }
        if (!this.order.customerPhone) {
            this.noticationService.create(this.translate.instant('core.active.notiPhone'));
            return;
        }
        if (!this.order.customerAddress) {
            this.noticationService.create(this.translate.instant('core.active.notiAddress'));
            return;
        }
        this.order.commissionStatus = false;
        this.order.status = 'WAITING';
        this.order.orderName = 'Thẻ game';
        this.loadingService.present();
        if (codeVoucher && codeVoucher.length > 0) {
            const filter = {
                where: {
                    code: codeVoucher
                },
                include: 'account'
            };
            this.voucherApi.findOne(filter)
                .subscribe((voucher: Voucher) => {
                    this.order.accountId = voucher.accountId;
                    this.orderApi.create(this.order)
                        .subscribe(() => {
                                this.onClickClose();
                                this.loadingService.dismiss();
                                this.noticationService.create(this.translate.instant('core.active.requestSuccess'));
                            }, error => {
                                this.loadingService.dismiss();
                                this.noticationService.create((this.translate.instant('core.active.error') + error.message));
                            }
                        );
                }, error1 => {
                    this.loadingService.dismiss();
                    this.noticationService.create(this.translate.instant('core.active.voucherIsNotExist'));
                });
        } else {
            this.orderApi.create(this.order)
                .subscribe(() => {
                        this.onClickClose();
                        this.loadingService.dismiss();
                        this.noticationService.create(this.translate.instant('core.active.requestSuccess'));
                    }, error => {
                        this.loadingService.dismiss();
                        this.noticationService.create((this.translate.instant('core.active.error') + error.message));
                    }
                );
        }
    }

    playSounds(file: string) {
        return new Promise((resolve, reject) => {
            this.soundMute = this.mapService.getSoundConfig();
            if (this.soundMute === true) {
                playSound(file).then(() => {
                    resolve('ok');
                }).catch(e => {
                    reject();
                });
            } else {
                resolve('ok');
            }
        });
    }
}
